import React, { useState, useEffect, useContext } from "react";
import { Grid, Card, CardContent, Typography, Box, Button, CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from "@mui/material";
import "./ExitManagement.css";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ToastContainer } from 'react-toastify';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as moment from "moment";
import ExitManagement_final from "./ExitManagementFinal";
import exitManagementAPI from "apis/panel/ExitManagement/exitManagement";
import swal from 'sweetalert';

import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";



import {

  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Paper

} from "@mui/material";
import EMS_Involuntary_Resign from "./EMS_Involuntary_Resign";

const ExitManagement = () => {

  const [resignations, setResignations] = useState([]);
  
  const [searchValue, setSearchValue] = useState("");

  const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination

  const [value, setValue] = useState("1");
  const [HRlist, setHRlist] = useState(true);
  const [resignationDetails, setResignationDetails] = useState("");
  const [approval, setApproval] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
   const [approvalReason, setApprovalReason] = useState("");
  const originalLWD = moment(resignationDetails.LWD).toDate(); // Store the original LWD
  const [selectedLWD, setSelectedLWD] = useState(null);
  const [reasonForChange, setReasonForChange] = useState("");
  const [isLWDChanged, setIsLWDChanged] = useState(false);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const limit = 10;
  const [offset, setOffset] = useState(1);

 const [openModal, setOpenModal] = useState(false);
   const [exitDetailsView,setExitDetailsView] = useState([])
   const [approvalDetails,setApprovalDetails] = useState([])

  const {getHRAllResignationsAPI,getOneResignationsAPI,hrUpdateResignationAPI,getResignationApprovalDetailsAPI} = exitManagementAPI()



  const handleOpenSubmitModal = async () => {
    let errors = {};

    if (!approval) {
      errors.approval = "Approval Status is required";
    }
    if (approval === "Rejected" && !rejectionReason.trim()) {
      errors.rejectionReason = "Reason for rejection is required";
    }
    if (isLWDChanged && !reasonForChange.trim()) {
      errors.reasonForChange = "Reason for LWD change is required";
    }
     if (approval === "Approved" && !approvalReason.trim()) {
      errors.approvalReason = "Reason for approval is required";
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      toast.error("Please fill in the required fields.");
      return;
    }
    const confirmation = await swal({
               title: "Confirm",
               text: " Are you sure you want to proceed with the Approve / Rejection?",
               icon: "warning",
               buttons: {
                 cancel: {
                   text: "Reject",
                   value: false,
                   visible: true,
                   className: "swal-button-disagree",
                 },
                 confirm: {
                   text: "Accept",
                   value: true,
                   visible: true,
                   className: "swal-button-agree",
                 },
               },
               dangerMode: false,
             });
   if(confirmation){
     handleApproveResignation(resignationDetails.exitId)
   }
  };



  useEffect(() => {
    fetchAllResignations();
  }, [offset]);

  useEffect(() => {
    if (resignationDetails.LWD) {
      setSelectedLWD(new Date(resignationDetails.LWD));
    }
  }, [resignationDetails]);

  const handleLWDChange = (newDate) => {
    if (!newDate) return;

    setSelectedLWD(newDate);

    const formattedDate = moment(newDate).format("YYYY-MM-DD");

    if (!moment(formattedDate).isSame(moment(resignationDetails.LWD).format("YYYY-MM-DD"), "day")) {
      setIsLWDChanged(true);
    } else {
      setIsLWDChanged(false);
      setReasonForChange("");
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const fetchAllResignations = async () => {
    try {
      const query ={
          offset: (offset - 1) * limit,
          limit: limit,

        }
      
      dispatch({ type: "SET_LOADING", payload: true });
     
      const data = await getHRAllResignationsAPI(query);

      if (data.status === "Ok" && Array.isArray(data.allResignations)) {
        setResignations(data.allResignations);
        setCount(data.count);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignations:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  
  const tableDataModal = resignations.map((resignation, index) => [
    
    index + 1 + (offset - 1) * limit,
    resignation.employeeCode, 
    resignation.firstName, 
    resignation.role, 
    resignation.dept, 
    resignation.requestStatus, 
    resignation?.attritionType ? resignation?.attritionType : 'Null',
   resignation.approvalStatus? resignation.approvalStatus === 'Manager Approved'?'L1 Manager Approved' :resignation.approvalStatus:'' ,
    moment(resignation.appliedOn).format("DD-MMM-YYYY"),
   resignation?.lwd ?moment(resignation.lwd).format("DD-MMM-YYYY"): 'Not Applicable',
    <Tooltip title="Click to view approval screen" key={resignation.exitId}>
      <span className="jobType">
        <RemoveRedEyeIcon
          style={{
          //   color: (resignation.requestStatus === "Applied" && ((resignation.approvalStatus === "Manager Approved" && resignation?.l2ApprovalStatus === 'Not Applicable') ||
          // (resignation.approvalStatus === "L2 Manager Approved" && resignation?.l2ApprovalStatus === 'Approved')) )
          color: (resignation.HrActionStatus === 'Active')
              ? "#E97000"  
              : "grey",    
          //   cursor: (resignation.requestStatus === "Applied" && ((resignation.approvalStatus === "Manager Approved" && resignation?.l2ApprovalStatus === 'Not Applicable') ||
          // (resignation.approvalStatus === "L2 Manager Approved" && resignation?.l2ApprovalStatus === 'Approved')) )
          cursor: (resignation.HrActionStatus === 'Active')
              ? "pointer" 
              : "not-allowed", 
          }}

          onClick={() => {
            // if (resignation.requestStatus === "Applied" && (resignation.approvalStatus === "Manager Approved" || resignation.approvalStatus === "HR Approved")) {
            if(resignation.HrActionStatus === 'Active'){
              fetchOneResignation(resignation.exitId);
            }
            else if(resignation.requestStatus === "Applied" && resignation.HrActionStatus === 'Not Active' &&  resignation.approvalStatus != 'HR Approved') {
              
             
                toast.info("This resignation has been Submitted and waiting for Manager Approvals")
              
            }else if(resignation.requestStatus === "Withdrawn"){

              toast.info("This resignation has been Withdrawn ")
            }
          }}
          disabled = {resignation.HrActionStatus === 'Not Active'}
          // disabled={!(resignation.requestStatus === "Applied" && (resignation.approvalStatus === "Manager Approved" || resignation.approvalStatus === "HR Approved"))}
        />
      </span>
    </Tooltip>,
     <Tooltip
        title={
       resignation.isMigrated
         ? "Migrated data – no details"
         : "Click to view approval Details"
     }
         key={resignation.exitId}
       >
         <span className="jobType">
           <InfoIcon
              style={{
           color: resignation.isMigrated
             ? "grey"
             : resignation.approvalStatus
             ? "#E97000"
             : "grey",
           cursor: resignation.isMigrated
             ? "not-allowed"
             : resignation.approvalStatus
             ? "pointer"
             : "not-allowed",
         }}
             onClick={() => {
               if (!resignation.isMigrated && resignation.approvalStatus) {
                 handleOpenDetails(resignation)
               }
             }}
           />
         </span>
       </Tooltip>
  ]);

  const fetchOneResignation = async (exitId) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });

      

      // Parse the response data
      const data = await getOneResignationsAPI(exitId);

      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {
        const resignationDetails = data.oneResignation[0];
        
        setResignationDetails(resignationDetails);
        setHRlist(false);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleApproveResignation = async (exitId) => {
    try {
     
      dispatch({ type: "SET_LOADING", payload: true });

      

      const body = {
        exitId,
        status: approval,
        ...(approval === "Approved"
          ? { lastWorkingDay: moment(selectedLWD).format("YYYY-MM-DD"), editReason: reasonForChange,approvalReason: approvalReason }
          : { rejectReason: rejectionReason })

      };

     
        const data = await hrUpdateResignationAPI(body);
        if (data.status === "Ok" && data.affected === 1) {
          if (approval === "Approved") {
            toast.success("Resignation approved successfully");
          } else if (approval === "Rejected") {
            toast.error("Resignation rejected successfully");
          } else {
            toast.info("Resignation status updated");
          }
          fetchAllResignations();
          setHRlist(true);
          setIsSubmitModalOpen(false);
          handleClose()
        } else {
          toast.error("Error: " + (data.message || "Approval failed"));
          setIsSubmitModalOpen(false);
          handleClose()
        }
      
    } catch (error) {
      toast.error("Error approving resignation: " + error.message);
      console.error("Error approving resignation:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
      setIsSubmitModalOpen(false);
    }
  };

    const handleOpenDetails= async (exitDetails)=>{
     try {
    
      dispatch({ type: "SET_LOADING", payload: true });

       const data = await getResignationApprovalDetailsAPI(exitDetails?.exitId);

      if (data.status === "Ok" && Array.isArray(data.oneResignation)) {
       
        const resignationDetails = data.oneResignation;

       setApprovalDetails(resignationDetails)
         setExitDetailsView(exitDetails)
        setOpenModal(true)
       
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignation details:", error);
    } finally {
     
      dispatch({ type: "SET_LOADING", payload: false });
    }
   
   

  }

    const handleClose = () => {
   setOpenModal(false);
  setExitDetailsView(null);
  setApprovalDetails(null)
  setApproval("")
  setRejectionReason("")
  setApprovalReason("")
  setErrorMessages({})
 
};

  {console.log(resignationDetails,'details')}
  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="HR View Tabs">
             <Tab label="Involuntary Resignation " value="3" className={value === '3' ? 'Leave' : 'nonleaveTab'} />
              <Tab label="Resignation Dashboard" value="1" className={value === '1' ? 'Leave' : 'nonleaveTab'} />
              <Tab label="Exit Closure Dashboard" value="2" className={value === '2' ? 'Leave' : 'nonleaveTab'} />
            </TabList>
          </Box>
          <TabPanel value="1">
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />


            <Typography
              variant="h5"
              align="center"
              className="self-title"

            >

              Resignation Dashboard
            </Typography>
          
            {HRlist ? (

              <ReusableTable

                data={tableDataModal} // Pass the transformed data
                count={count}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                setSearchValue={setSearchValue}
                heading={[
                  "S.No",
                  "Employee Code",
                  "Name",
                  "Role",
                  "Department",
                  "Request Status",
                  "Attrition Type",
                  "Approval Status",
                  "Request Submission Date",
                  "Last Working Day",
                  "Action",
                  "View Details"
                ]}
              />
            ) : (
              <>
                <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
                
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee ID</Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kraCategory"
                      name="kraCategory"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.employeeCode}
                      InputProps={{ readOnly: true }} // Make it readonly
                    />
                  </Grid>

                  
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee Name </Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kpiName"
                      name="kpiName"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.firstName}
                      InputProps={{ readOnly: true }} // Make it readonly
                    />
                  </Grid>

                 { resignationDetails?.requestStatus != 'Withdrawn' &&(

                <>
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Reason For Leaving</Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kpiName"
                      name="kpiName"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.exitReason}
                      InputProps={{ readOnly: true }} // Make it readonly
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Last Working Date</Box>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        id="lastWorkingDate"
                        name="lastWorkingDate"
                        value={selectedLWD}
                        onChange={handleLWDChange}
                        format="dd/MM/yyyy"
                       
                        slotProps={{ textField: { required: true } }} // Ensures field is mandatory
                        renderInput={(params) => (
                          <TextField
                            {...params}

                            required
                            InputProps={{ readOnly: true }} // Prevents manual clearing
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  </>
 )} 
                 
                  {isLWDChanged && (
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                      <Box className="label">
                        Reason for LWD Change<span style={{ color: "red" }}>*</span>
                      </Box>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={reasonForChange}
                        onChange={(e) => setReasonForChange(e.target.value.trimStart())} // Prevent leading spaces
                        onBlur={(e) => setReasonForChange(e.target.value.trim())}
                        placeholder="Enter reason for LWD change"
                     
                      />
                      {errorMessages.reasonForChange && <FormHelperText>{errorMessages.reasonForChange}</FormHelperText>}

                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Approval Status<span style={{ color: "red" }}>*</span></Box>
                    <FormControl fullWidth>
                      <Select
                        labelId="self-rating-label"
                        id="selfRating"
                        style={{ border: "2px solid #B2D6F8", color: "grey" }}
                        value={approval}
                        onChange={(e) => setApproval(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>Select</MenuItem>
                        <MenuItem value="Approved">Approve</MenuItem>
                        <MenuItem value="Rejected">Reject</MenuItem>
                      </Select>
                      {errorMessages.approval && <FormHelperText>{errorMessages.approval}</FormHelperText>}

                    </FormControl>
                  </Grid>

                  {/* Conditionally Render TextField for Rejection Reason */}
                  {approval === "Rejected" && (
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                      <Box className="label">Reason for Rejection<span style={{ color: "red" }}>*</span></Box>

                      <TextField
                        sx={{ border: "1px solid #B2D4F8" }}
                        id="justification"
                        name="justification"
                        placeholder="Enter reason for rejection"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value.trimStart())} // Prevent leading spaces
                        onBlur={(e) => setRejectionReason(e.target.value.trim())}
                     

                      />
                      {errorMessages.rejectionReason && <FormHelperText>{errorMessages.rejectionReason}</FormHelperText>}

                    </Grid>
                  )}

                  {approval === "Approved" && (
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                      <Box className="label">Reason for Approval<span style={{ color: "red" }}>*</span></Box>

                      <TextField
                        sx={{ border: "1px solid #B2D4F8" }}
                        id="justification"
                        name="justification"
                        placeholder="Enter reason for approval"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={approvalReason}
                        onChange={(e) => setApprovalReason(e.target.value.trimStart())} 
                        onBlur={(e) => setApprovalReason(e.target.value.trim())}

                      />
                      {errorMessages.approvalReason && <FormHelperText>{errorMessages.approvalReason}</FormHelperText>}

                    </Grid>
                  )}

               

                </Grid>
                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="cancelButton" onClick={() => {
                      setSelectedLWD(originalLWD); 
                      setIsLWDChanged(false);
                      setReasonForChange(""); 
                      setHRlist(true); 
                      handleClose()
                    }}>Cancel</Button>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="saveButton" onClick={() => handleOpenSubmitModal()}> Submit </Button>
                  </Grid>
                </Grid>

              </>
            )}

          </TabPanel>
          <TabPanel value="2">
            <ExitManagement_final />
          </TabPanel>
          <TabPanel value="3">
            <EMS_Involuntary_Resign/>
          </TabPanel>
        </TabContext>


     <Dialog
       open={openModal}
       onClose={handleClose}
       PaperProps={{
         sx: {
           width: "800px",
           maxWidth: "90vw",
           borderRadius: "12px",
           padding: "20px",
       
         },
       }}
       sx={{
         "& .MuiDialog-container": {
           alignItems: "flex-center",  
         },
       }}
       
     
     >
       <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", color: "#4a55cbff" }}>
        Employee Exit Progress Details
         <IconButton
           aria-label="close"
           onClick={handleClose}
           sx={{
             position: "absolute",
             right: 8,
             top: 8,
             color: "#666",
           }}
         >
           <CloseIcon />
         </IconButton>
       </DialogTitle>
      {exitDetailsView && (
       <>
         <Grid container spacing={1} sx={{ mb:3,pl: 1, pr: 1, mt: 1, justifyContent: "space-around" }}>
           <Grid item xs={12} sm={4} >
             <strong >Employee Name:</strong> {exitDetailsView.firstName}
           </Grid>
           <Grid item xs={12} sm={4}>
             <strong>Request Status:</strong> {exitDetailsView.requestStatus}
           </Grid>
           
                   <Grid item xs={12} sm={4}>
                   <strong>Attrition Type:</strong> {exitDetailsView.attritionType}
                 </Grid>
              
         </Grid>
          <TableContainer component={Paper}>
             <Table size="medium">
              <TableHead>
       <TableRow>
         <TableCell sx={{ width: "15%", minWidth: "120px" }}>
           <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
             Approval Level
           </Typography>
         </TableCell>
          <TableCell sx={{ width: "15%", minWidth: "120px" }}>
           <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
             Acted By
           </Typography>
         </TableCell>
         <TableCell sx={{ width: "15%", minWidth: "120px" }}>
           <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
             Status
           </Typography>
         </TableCell>
          <TableCell sx={{ width: "15%", minWidth: "120px" }}>
           <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
             Acted On
           </Typography>
         </TableCell>
         <TableCell sx={{ width: "15%", minWidth: "120px" }}>
           <Typography sx={{ fontWeight: "bold", color: "#646aadff" }}>
             Reason/Remarks
           </Typography>
         </TableCell>
        
        
       </TableRow>
     </TableHead>
    
               <TableBody>
       {[
         "Manager (level 1)",
         "Manager (level 2)",
         "HR",
         "IT",
         "Admin",
         "Finance",
         "HR Final Approval"
       ].map((levelName) => {
         const detail = approvalDetails?.find(
           (item) => item.approvalLevel === levelName
         );
    
         
       
     const getApprovalStatus = (approvalDetails, levelName) => {
    
      
if (!approvalDetails) return  <span style={{ color: "gray",fontWeight: "bold" }}>Not Applicable</span>;
let status;
  switch (levelName) {
    case "Manager (level 1)":
      status = approvalDetails?.managerStatus || "Pending";
      break;
    case "Manager (level 2)":
      status =  approvalDetails?.l2ManagerStatus || "Pending";
      break;
    case "HR":
      status =  approvalDetails?.HRStatus || "Pending";
      break;
    case "IT":
      status = approvalDetails?.ITStatus || "Pending";
      break;
    case "Admin":
      status =  approvalDetails?.adminStatus || "Pending";
      break;
    case "Finance":
      status = approvalDetails?.financeStatus || "Pending";
      break;
    case "HR Final Approval":
      status = approvalDetails?.hrFinalApprovalStatus || "Pending";
      break;
    default:
      status = approvalDetails?.approvalStatus || "Not Applicable";
  }
   let color;
switch (status) {
    case "Approved":
      color = "#327841ff";
      break;
      case "Completed":
      color = "#327841ff";
      break;
    case "Pending":
      color = "#727163ff";
      break;
    case "Rejected":
      color = "#d02222ff";
      break;
    case "Not Applicable":
      color = "#859ea3ff";
      break;
    default:
      color = "black";
  }

return <span style={{ color,fontWeight: "bold" }}>{status}</span>;
};
         return (
           <TableRow key={levelName}>
             <TableCell>{levelName}</TableCell>
             <TableCell>{detail?.approverName || "-"}</TableCell>
            <TableCell>
       {/* <Typography
       
         sx={{
           
           color:
             detail?.approvalStatus === "Approved" ||  detail?.approvalStatus === "Completed"
               ? "green"
               : detail?.approvalStatus === "Rejected"
               ? "red"
               : "#797c61ff", 
         }}
       >
         {detail?.approvalStatus
          ? detail.approvalStatus
          : exitDetailsView.attritionType == "Voluntary" || (exitDetailsView?.requestStatus == 'Withdrawn' && levelName == 'Manager (level 1)' )
          ? "Pending"
          : "Not Applicable"}
       </Typography> */}

        {getApprovalStatus(approvalDetails[0], levelName)}
     </TableCell>
             <TableCell>
               {detail?.date
                 ? moment(detail.date).format("DD-MM-YYYY")
                 : "-"}
             </TableCell>
             <TableCell>{detail?.remarks || "-"}</TableCell>
           </TableRow>
         );
       })}
     </TableBody>
     
             </Table>
           </TableContainer>
         </>
       )}
     </Dialog> 


      </Box>
    </div>
  );
};

export default ExitManagement;

